import { Entry } from './entry';

Entry.displayName = 'Tappable';

export { Entry as Tappable };

export { StateMode as TappableStateMode } from './enums';

export type { Props as TappableProps } from './types';
